import React from 'react';

import styled from '@emotion/styled';

import useDownLoadBinQRCode from '../../../hooks/racks/useDownloadBinQRCode';
import { formateDatimeStrToNiajaTime } from '../../../utils/utils';
import { HoverDropDown } from '../../DropDown/DropDown';
import DownloadIcon from '../../Icons/DownloadIcon';
import HorizontalDot from '../../Icons/HorizontalDot';

interface IIconContainer {
  data: any;
}

const IconContainer: React.FC<IIconContainer> = ({ data }) => {
  const { getDownLoadBinQRCode } = useDownLoadBinQRCode();

  const downLoadBarCode = (e: any) => {
    getDownLoadBinQRCode(data.binId);
  };
  return (
    <IconContainerWrapper
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <HoverDropDown className="options" label={<HorizontalDot />}>
        <DropDownContent
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            downLoadBarCode(e);
            e.stopPropagation();
          }}
        >
          <DownloadIcon /> Download Barcode
        </DropDownContent>
      </HoverDropDown>
    </IconContainerWrapper>
  );
};

interface IUpdatedDateComponent {
  children: string;
  tModalData: any;
}

const UpdatedDateComponent: React.FC<IUpdatedDateComponent> = ({
  children,
  tModalData,
}) => {
  return (
    <Container>
      {children && formateDatimeStrToNiajaTime(children)}
      <IconContainer data={tModalData} />
    </Container>
  );
};

export default UpdatedDateComponent;

const DropDownContent = styled.div`
  display: flex;
  padding: 1rem;
  gap: 0.5rem;
  align-items: center;
  width: 180px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.brandBackdrop};
  }
`;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;

const IconContainerWrapper = styled.div`
  display: flex;
  /* border: 1px solid green; */
  padding: 0.25rem 0.5rem;
`;
